'use es6';

import { createSelector } from 'reselect';
import { selectHasBusinessUnitsAccess } from 'dashboard-lib/public/userInfo/scopes';
export const CHECKBOX = 'CHECKBOX';
const FAVORITES = 'FAVORITES';
const NAME = 'NAME';
const DASHBOARD_COUNT = 'DASHBOARD_COUNT';
const REPORT_OWNER_NAME = 'REPORT_OWNER_NAME';
export const BUSINESS_UNIT = 'BUSINESS_UNIT';
const ACCESS_CLASSIFICATION = 'ACCESS_CLASSIFICATION';
export const UPDATED_AT = 'UPDATED_AT';
export const LAST_VIEWED = 'LAST_VIEWED_AT';
const ALL_COLUMNS = [{
  key: CHECKBOX,
  isSortable: false,
  width: '70px'
}, {
  key: FAVORITES,
  isSortable: false,
  width: '50px'
}, {
  key: NAME,
  labelKey: 'reports.table.header.NAME',
  isSortable: true,
  width: '350px'
}, {
  key: DASHBOARD_COUNT,
  labelKey: 'reports.table.header.DASHBOARD_COUNT',
  isSortable: false,
  width: '100px'
}, {
  key: REPORT_OWNER_NAME,
  labelKey: 'reports.table.header.REPORT_OWNER_NAME',
  isSortable: true,
  width: '160px'
}, {
  key: BUSINESS_UNIT,
  labelKey: 'reports.table.header.BUSINESS_UNIT',
  isSortable: false,
  width: '160px',
  getVisibility: ({
    hasBusinessUnitsAccess
  }) => hasBusinessUnitsAccess
}, {
  key: ACCESS_CLASSIFICATION,
  labelKey: 'reports.table.header.ACCESS_CLASSIFICATION',
  isSortable: true,
  width: '160px'
}, {
  key: LAST_VIEWED,
  labelKey: 'reports.table.header.LAST_VIEWED_WITH_TIMEZONE',
  isSortable: true,
  width: '185px',
  tooltipLabel: 'reports.table.header.LAST_VIEWED_TOOLTIP'
}, {
  key: UPDATED_AT,
  labelKey: 'reports.table.header.UPDATED_AT_WITH_TIMEZONE',
  isSortable: true,
  width: '160px'
}];
export const selectVisibleColumns = createSelector(selectHasBusinessUnitsAccess, hasBusinessUnitsAccess => ALL_COLUMNS.filter(columnData => !columnData.getVisibility || columnData.getVisibility({
  hasBusinessUnitsAccess
})));